import { graphqlClient } from "../../../client";
import getWalletTransactionsDocument from "./getWalletTransactionsQuery.graphql";
import type { WalletTransactionConnectionType } from "../../types";

export interface GetWalletTransactionsQueryVariables {
  walletId: string;
  skip?: number;
  take?: number;
  transactionType?: string;
  startDate?: string;
  endDate?: string;
}

export interface GetWalletTransactionsQueryResult {
  walletTransactions: WalletTransactionConnectionType;
}

export async function getWalletTransactions(
  payload: GetWalletTransactionsQueryVariables,
): Promise<WalletTransactionConnectionType> {
  const { data } = await graphqlClient.query<GetWalletTransactionsQueryResult, GetWalletTransactionsQueryVariables>({
    query: getWalletTransactionsDocument,
    variables: payload,
  });

  return (
    data?.walletTransactions ?? {
      totalCount: 0,
      items: [],
    }
  );
}
